import { FieldProps } from "../../types";

interface InputEditorProps extends FieldProps<string> {}

const InputEditor: React.FC<InputEditorProps> = () => {
  return <></>;
};

export default InputEditor;
